import { useState } from "react";
import classnames from "classnames";
import { useStoreState } from "pullstate";

import Input from "@/components/Input";
import FiltersDropdown from "@/components/FiltersDropdown";
import SearchIcon from "@/icons/search.svg";
import { UIStore } from "@/store/UIStore";
import { useScroll } from "@/helpers/useScroll";

import styles from "./Filters.module.scss";
import { FiltersInterface, FiltersVariant } from "./Filters.interface";

const Filters: React.FC<FiltersInterface> = ({
  handleSearchChange,
  handleSortChange,
  handleDropdownChange,
  sortOptions,
  sortTitle,
  placeholder,
  variant,
  className,
}) => {
  const [buttonIndex, setButtonIndex] = useState<number>(0);
  const { userLoggedIn } = useStoreState(UIStore, (store) => store);
  const { scrollWrapperRef } = useScroll();

  const withDropdown =
    variant === FiltersVariant.Sort ||
    (userLoggedIn && variant === FiltersVariant.SortAndFilter);
  const withSortButtons = variant === FiltersVariant.SortAndFilter;

  const sortButtonOptions = [
    {
      name: " Od najnowszych",
      value: "published_at-desc",
    },
    {
      name: " Od najstarszych",
      value: "published_at-asc",
    },
    {
      name: " Najpopularniejsze",
      value: "popularity-desc",
    },
  ];

  const changeSortOption = (index: number, value: string) => {
    setButtonIndex(index);
    handleSortChange(value);
  };

  return (
    <div className={classnames(styles.filters, className)}>
      {withSortButtons && (
        <div className={styles.sortButtons} ref={scrollWrapperRef}>
          {sortButtonOptions.map(({ name, value }, index) => (
            <button
              key={index}
              className={classnames(
                styles.button,
                buttonIndex === index && styles.active
              )}
              onClick={() => changeSortOption(index, value)}
            >
              {name}
            </button>
          ))}
        </div>
      )}
      <Input
        placeholder={placeholder}
        className={styles.search}
        icon={SearchIcon}
        handleChange={handleSearchChange}
      />
      {withDropdown && (
        <FiltersDropdown
          onChange={handleDropdownChange}
          options={sortOptions}
          title={sortTitle}
        />
      )}
    </div>
  );
};

export default Filters;
